export class WorkspaceGcpStorageAccessConfiguration {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allowedCredentialProfiles",
            "baseName": "allowedCredentialProfiles",
            "type": "Array<WorkspaceStorageAllowedCredentialsProfile>",
            "format": ""
        },
        {
            "name": "allowedPrincipals",
            "baseName": "allowedPrincipals",
            "type": "Array<WorkspaceAllowedPrincipal>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return WorkspaceGcpStorageAccessConfiguration.attributeTypeMap;
    }
    constructor() {
    }
}
